import type { ComponentStyleConfig } from "@chakra-ui/theme";

const Skeleton: ComponentStyleConfig = {
  baseStyle: {
    w: "100%"
  },
};

export default Skeleton;